export default "__VITE_ASSET__DuHLrCGs__"